module.exports = __webpack_public_path__ + "img/antes_despues_118.d5851aed.png";